<h3 *ngIf="isWithinRegularRange">Spil med i næste trækning inden</h3>
<h3 *ngIf="isWithinDrawPeriodRange">Resultaterne offentliggøres her om</h3>
<div class="mt-2 mb-5 mx-auto">
    <app-countdown-v3 [countdownDate]="t" #countdown></app-countdown-v3>
</div>
